import { axiosTokenInstance } from 'src/utils/axiosInstance.utils';
import { apiUrls } from 'src/utils/properties.utils';
import { User } from 'src/models/Management.interface';

export const getAllUsers = async (
  offset: number,
  limit: number,
  search: string,
  sortBy: string,
  order: 'ASC' | 'DESC'
): Promise<{
  data: User[];
  totalItems: number;
  currentPage: number;
  totalPages: number;
}> => {
  try {
    const response = await axiosTokenInstance.get(apiUrls.USER_MANAGEMENT, {
      params: {
        offset,
        limit,
        search,
        sortBy,
        order,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getUserInfoByEmail = async (email: string): Promise<User> => {
  try {
    const response = await axiosTokenInstance.get(
      apiUrls.GET_USER_INFO_BY_EMAIL,
      {
        params: { email },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const addUser = async (payload: {
  firstName: string;
  lastName: string;
  email: string;
  roles: string[];
}): Promise<{ message: string }> => {
  try {
    const response = await axiosTokenInstance.post(apiUrls.ADD_USER, payload);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const editUser = async (payload: {
  id: string;
  requesterUserId: string;
  email: string;
  firstName: string;
  lastName: string;
  roles: string[];
}): Promise<{ message: string; user: User }> => {
  try {
    const response = await axiosTokenInstance.put(apiUrls.EDIT_USER, payload);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const toggleUserActivation = async (
  id: string,
  isActive: boolean
): Promise<{ message: string }> => {
  try {
    const response = await axiosTokenInstance.patch(apiUrls.USER_ACTIVATION, {
      id,
      isActive,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getUserEmailById = async (
  userId: string | number
): Promise<{ email: string }> => {
  try {
    const response = await axiosTokenInstance.get(apiUrls.GET_USER_EMAIL, {
      params: { userId },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteUserById = async (
  userId: string
): Promise<{ message: string }> => {
  const response = await axiosTokenInstance.delete(
    `${apiUrls.DELETE_USER_BY_ID}/${userId}`
  );
  return response.data;
};

export const getCompanyRoles = async (): Promise<
  { value: string; label: string }[]
> => {
  try {
    const response = await axiosTokenInstance.get<string[]>(
      apiUrls.GET_COMPANY_ROLES
    );
    return response.data
      .filter((role) => role.toUpperCase() !== 'OWNER')
      .map((role) => ({
        value: role,
        label: role.charAt(0).toUpperCase() + role.slice(1).replace('_', ' '),
      }));
  } catch (error) {
    return Promise.reject(error);
  }
};
export const adminResetPassword = async (payload: {
  id: string;
  requesterUserId: string;
  newPassword: string;
}): Promise<{ message: string }> => {
  try {
    const response = await axiosTokenInstance.put(
      apiUrls.ADMIN_RESET_PASSWORD,
      payload
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
